import { Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ProjectBankService } from '../../../../core/services/project-bank.service';

@Component({
  standalone: true,
  imports: [RouterLink],
  templateUrl: './project-bank-detail.component.html',
  styleUrl: './project-bank-detail.component.css'
})
export class ProjectBankDetailComponent { private readonly bank = inject(ProjectBankService); private readonly route = inject(ActivatedRoute); get project() { return this.bank.find(this.route.snapshot.paramMap.get('id') ?? ''); } }
